import { render, staticRenderFns } from "./EventFormSessions.vue?vue&type=template&id=bd7c43a6&scoped=true"
import script from "./EventFormSessions.vue?vue&type=script&lang=js"
export * from "./EventFormSessions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7c43a6",
  null
  
)

export default component.exports